
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bienvenue/[[...lang]]",
      function () {
        return require("private-next-pages/bienvenue/[[...lang]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bienvenue/[[...lang]]"])
      });
    }
  